import { Region as RegionDto } from "src/app/proxy/regions";

export class Region {
  locationId: number;
  name?: string;
  isMainSupervisor: boolean;

  constructor(dto: RegionDto) {
    Object.assign(this, dto);
  }
}